document.addEventListener("DOMContentLoaded", () => {
    let splideBlogSlider = new Splide(".blog-category-slide", {
        perPage: 1,
        type: "loop",
        pagination: true,
        arrows: false,
    });
    splideBlogSlider.mount();
});

